import { startGoogleLogin } from "@/pages/auth/AuthCallback";

/**
 * "Continuar con Google" button — reusable on Login and Registro pages.
 */
export default function GoogleSignInButton({ label = "Continuar con Google" }) {
  return (
    <button
      type="button"
      onClick={startGoogleLogin}
      data-testid="google-signin-btn"
      style={{
        width: "100%",
        background: "white",
        color: "#1f2937",
        border: "1px solid #d1d5db",
        padding: "11px 14px",
        borderRadius: 10,
        fontWeight: 600,
        fontSize: 14,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
        transition: "background 0.15s, box-shadow 0.15s",
      }}
      onMouseOver={(e) => { e.currentTarget.style.background = "#f9fafb"; e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.08)"; }}
      onMouseOut={(e) => { e.currentTarget.style.background = "white"; e.currentTarget.style.boxShadow = "none"; }}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18A11 11 0 001 12c0 1.77.42 3.45 1.18 4.93l3.66-2.84z" />
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z" />
      </svg>
      {label}
    </button>
  );
}
